/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */

import {
  GET_ASSET_CONTACTS_SUCCESS,
  GET_ASSET_CONTACTS_FAILURE,
  ADD_ASSET_CONTACT_SUCCESS,
  ADD_ASSET_CONTACT_FAILURE,
  UPDATE_ASSET_CONTACT_SUCCESS,
  UPDATE_ASSET_CONTACT_FAILURE,
  DELETE_ASSET_CONTACT_SUCCESS,
  DELETE_ASSET_CONTACT_FAILURE,
  GET_ALL_CONTACTS,
  GET_ALL_CONTACTS_SUCCESS,
  ADD_CONTACT,
  ADD_CONTACT_SUCCESS,
  ADD_CONTACT_FAILURE,
  DELETE_CONTACT,
  DELETE_CONTACT_SUCCESS,
  DELETE_CONTACT_FAILURE,
  UPDATE_CONTACT,
  UPDATE_CONTACT_SUCCESS,
  UPDATE_CONTACT_FAILURE
} from "../actions/actionTypes";

import {
  setLoadingState,
  setSuccessResponse,
  setErrorResponse
} from "./reducerUtils";

const initialState = {
  contacts: [],
  contact: {
    data: null,
    state: "INIT",
    error: null
  },
  allContacts: {
    data: null,
    state: "INIT",
    error: null
  }
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_ASSET_CONTACTS_SUCCESS:
      return {
        loadingContactsSuccess: true,
        contacts: action.payload.contacts
      };

    case GET_ASSET_CONTACTS_FAILURE:
      return {
        loadingContactsSuccess: false,
        error: action.err.message,
        contacts: state.contacts
      };

    case ADD_ASSET_CONTACT_SUCCESS:
      return {
        addingSuccess: true,
        contacts: action.payload.contacts
      };

    case ADD_ASSET_CONTACT_FAILURE:
      return {
        addingSuccess: false,
        error: action.err.message,
        contacts: state.contacts
      };

    case UPDATE_ASSET_CONTACT_SUCCESS:
      return {
        updatingSuccess: true,
        contacts: action.payload.contacts
      };

    case UPDATE_ASSET_CONTACT_FAILURE:
      return {
        updatingSuccess: false,
        error: action.err.message,
        contacts: state.contacts
      };

    case DELETE_ASSET_CONTACT_SUCCESS:
      return {
        deletingSuccess: true,
        contacts: action.payload.contacts
      };

    case DELETE_ASSET_CONTACT_FAILURE:
      return {
        deletingSuccess: false,
        error: action.err.message,
        contacts: state.contacts
      };

    case GET_ALL_CONTACTS:
      return setLoadingState(state, "allContacts");

    case GET_ALL_CONTACTS_SUCCESS:
      return setSuccessResponse(state, action, "allContacts");

    case ADD_CONTACT:
      return setLoadingState(state, "contact", "ADD");

    case ADD_CONTACT_SUCCESS:
      return setSuccessResponse(state, action, "contact", "ADD");
    case ADD_CONTACT_FAILURE:
      return setErrorResponse(state, action, "contact", "ADD");
    case DELETE_CONTACT:
      return setLoadingState(state, "contact", "DELETE");

    case DELETE_CONTACT_SUCCESS:
      return setSuccessResponse(state, action, "contact", "DELETE");

    case DELETE_CONTACT_FAILURE:
      return setErrorResponse(state, action, "contact", "DELETE");

    case UPDATE_CONTACT:
      return setLoadingState(state, "contact", "UPDATE");

    case UPDATE_CONTACT_SUCCESS:
      return setSuccessResponse(state, action, "contact", "UPDATE");

    case UPDATE_CONTACT_FAILURE:
      return setErrorResponse(state, action, "contact", "UPDATE");

    default:
      return state;
  }
}
